import { IWorkstation } from '@relab/alstom-ptw-shared';

import { ActionType, AppActionTypes } from '../types';

export function workstationCreateAction(workstation: any): AppActionTypes {
  return {
    type: ActionType.WORKSTATION_CREATE,
    payload: {
      request: {
        url: '/workstation',
        method: 'post',
        data: {
          ...workstation,
        },
      },
    },
  };
}

export function workstationsAction(): AppActionTypes {
  return {
    type: ActionType.WORKSTATIONS,
    payload: {
      request: {
        url: '/workstations',
        method: 'get',
      },
    },
  };
}

export function workstationUpsertAction(params: IWorkstation): AppActionTypes {
  return {
    type: ActionType.WORKSTATION_UPSERT,
    payload: {
      workstation: {
        ...params,
      },
    },
  };
}

export function workstationDeleteAction(workstationId: string): AppActionTypes {
  return {
    type: ActionType.WORKSTATION_DELETE,
    payload: {
      request: {
        url: `/workstation/${workstationId}`,
        method: 'delete',
      },
      workstation: {
        _id: workstationId,
      },
    },
  };
}
